import React from 'react';

import { useSubmitQualityControlCheckMutation } from 'generated/graphql';
import * as types from './types';



export function useSubmitQualityControlCheck(returnAuthorizationId: string) {
  const [fnMutate, tuple] = useSubmitQualityControlCheckMutation({});

  const fnWrappedMutate = React.useCallback(
    async (formState: types.IFormState) => {
      if (formState.softwareVersion) {
        await fnMutate({
          variables: {
            input: {
              returnAuthorizationId,
              softwareVersionId: formState.softwareVersion?.id
            }
          }
        });
      }
    },
    [
      fnMutate,
      returnAuthorizationId
    ]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
